import React, { useState, useEffect, Suspense, lazy } from 'react';
import styled from 'styled-components';
import { Box, Flex, StyledProgressiveImage } from 'src/kit';

import logo1 from 'images/update_landing/companies/Alexa_Capital.png';
import logo3 from 'images/update_landing/companies/Banque-Hottinguer.png';
import logo4 from 'images/update_landing/companies/Cathay-Capital.png';
import logo5 from 'images/update_landing/companies/CNP.png';
import logo6 from 'images/update_landing/companies/D_Angelin_Co.png';
import logo7 from 'images/update_landing/companies/FDC.png';
import logo8 from 'images/update_landing/companies/Greenhill.png';
import logo9 from 'images/update_landing/companies/Infravia.png';
import logo10 from 'images/update_landing/companies/Meanings.png';
import logo11 from 'images/update_landing/companies/Sagard.png';
import logo12 from 'images/update_landing/companies/Zaoui&Co.png';

const Slider = lazy(() =>
  import(/* webpackChunkName: "slick-slider" */ 'react-slick').then(m => {
    return Promise.all([import('slick-carousel/slick/slick.css'), import('slick-carousel/slick/slick-theme.css')]).then(
      () => m
    );
  })
);

const responsive = [
  {
    breakpoint: 1300,
    settings: {
      slidesToShow: 4
    }
  },
  {
    breakpoint: 1000,
    settings: {
      slidesToShow: 3
    }
  },
  {
    breakpoint: 800,
    settings: {
      slidesToShow: 2
    }
  }
];

const Image = props => (
  <StyledProgressiveImage
    mx="auto"
    backgroundSize="contain"
    backgroundRepeat="no-repeat"
    backgroundPosition="center"
    {...props}
  />
);

const SliderWrapper = styled(Box)`
  width: 100%;

  .slick-list {
    overflow: hidden;
  }

  .slick-track {
    display: flex !important;
    align-items: center !important;
  }

  .slick-slide {
    display: flex !important;
    justify-content: center;
    align-items: center;
    height: auto !important;
    float: none !important;
  }

  .slick-slide > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
`;

const SliderInner = () => {
  const [isClient, setIsClient] = useState(false);
  const [sliderReady, setSliderReady] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const timer = setTimeout(() => {
      setSliderReady(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  if (!isClient) {
    return null;
  }

  return (
    <>
      {sliderReady ? (
        <SliderWrapper>
          <Slider
            responsive={responsive}
            mobileFirst
            infinite
            autoplay
            autoplaySpeed={0}
            speed={3000}
            slidesToScroll={1}
            slidesToShow={5}
            arrows={false}
          >
            <Image src={logo1} alt="company icon" height={80} width={120} />
            <Image src={logo3} alt="company icon" height={50} width={100} />
            <Image src={logo4} alt="company icon" height={80} width={120} />
            <Image src={logo5} alt="company icon" height={60} width={100} />
            <Image src={logo6} alt="company icon" height={130} width={150} />
            <Image src={logo7} alt="company icon" height={50} width={100} />
            <Image src={logo8} alt="company icon" height={80} width={120} />
            <Image src={logo9} alt="company icon" height={80} width={120} />
            <Image src={logo10} alt="company icon" height={50} width={100} />
            <Image src={logo11} alt="company icon" height={80} width={120} />
            <Image src={logo12} alt="company icon" height={35} width={80} />
          </Slider>
        </SliderWrapper>
      ) : (
        <Box style={{ height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ color: '#8a99a8' }}>Loading...</span>
        </Box>
      )}
    </>
  );
};

const CompaniesSlider = ({ bg = '#F4F6F9', ...props }) => (
  <Box as="section" py={5} {...props} bg={bg}>
    <Flex width={1} flexDirection="column" justifyContent="center">
      <Suspense fallback={null}>
        <SliderInner />
      </Suspense>
    </Flex>
  </Box>
);

export default CompaniesSlider;